<template lang="pug">
  div
    v-container.py-0(style="max-width: 600px;" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'px-5'")
      div.py-1.scrolling-wrapper(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08} !important`")
        v-btn.mr-1.ml-3(color="transparent" small icon @click="showFilter('sort')")
          v-icon(color="basic600" size="20") mdi-sort
        v-chip.s2.mx-1.text-capitalize(v-if="filters.range.name !== 'All'" color="info500" small :dark="Boolean(selectedFilter === 'date')" :outlined="Boolean(selectedFilter !== 'date')" :style="selectedFilter !== 'date' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('date')") {{ filters.range.name }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'date' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        v-chip.s2.mx-1.text-capitalize(v-if="filters.tier" color="info500" small :dark="Boolean(selectedFilter === 'tier')" :outlined="Boolean(selectedFilter !== 'tier')" :style="selectedFilter !== 'tier' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('tier')") {{ tierName(filters.tier) }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'tier' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}

    v-container.pa-0(v-if="selectedFilter" style="max-width: 600px")
      .sort(v-if="selectedFilter === 'sort'")
        payout-sort.pa-6(:parentSort.sync="sort")

      .date(v-if="selectedFilter === 'date'")
        payout-date.pa-6(:parentRange.sync="range")

      .tier-level(v-if="selectedFilter === 'tier'")
        payout-tier.pa-6(:parentTier.sync="tier" :companyTiers="companyTiers")

      div.d-flex.align-center.pa-4
        v-spacer
        v-btn(v-if="selectedFilter !== 'sort'" color='white', text @click="removeFilter")
          .button-Aa-small.primary400--text Remove
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="updateFilter" dark)
          .button-AA-small.basic100--text Update
</template>

<script>
import PayoutSort from '@/components/resellers/payouts/PayoutSort.vue'
import PayoutDate from '@/components/resellers/payouts/PayoutDate.vue'
import PayoutTier from '@/components/resellers/payouts/PayoutTier.vue'

export default {
  name: 'PayoutListFiltersChip',
  components: { PayoutSort, PayoutDate, PayoutTier },
  props: {
    company: {
      type: Object,
      required: true
    },
    companyTiers: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    selectedFilter: null,
    sort: null,
    range: null,
    tier: null
  }),
  watch: {
    filters: {
      deep: true,
      handler() {
        this.checkFilter()
      }
    }
  },
  mounted() {
    this.checkFilter()
  },
  methods: {
    checkFilter() {
      this.sort = this.filters.sort
      this.range = this.filters.range
      this.tier = this.filters.tier
    },
    showFilter(filter) {
      if (this.selectedFilter === filter) {
        this.selectedFilter = null
      } else {
        this.selectedFilter = filter
      }
    },
    tierName(tierId) {
      return this.companyTiers.find(tier => tier.id === tierId).name 
    },
    updateFilter() {
      const filters = {
        sort: this.sort,
        range: this.range,
        tier: this.tier
      }
      this.$emit('updateFilter', filters)
      this.selectedFilter = null
    },
    removeFilter() {
      if (this.selectedFilter === 'sort') {
        this.sort = 'newest'
      } else if (this.selectedFilter === 'date') {
        this.range = {
          name: 'All',
          value: null,
          date: null
        }
      } else if (this.selectedFilter === 'tier') {
        this.tier = null
      }
      this.updateFilter()
    }
  }
}
</script>

<style lang="scss" scoped>
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>